import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";

const WA_LINK =
  "https://wa.me/919972554702?text=" +
  encodeURIComponent(
    "Hello Mandar, I'd like a growth conversation for my company."
  );

export default function GrowthHero() {
  return (
    <section
      id="top"
      data-testid="growth-hero"
      className="relative min-h-[92vh] flex items-center sebyx-grid-bg overflow-hidden"
    >
      <div className="px-6 md:px-12 lg:px-24 pt-28 pb-16 w-full">
        <div className="flex items-center gap-3 mb-8 sebyx-rise">
          <span className="block w-8 h-px bg-sebyx-accent" />
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-sebyx-accent">
            [01] Growth Partner · Manufacturing &amp; Industrial
          </span>
        </div>

        <h1
          data-testid="growth-hero-headline"
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter text-sebyx-text leading-[1.04] max-w-5xl sebyx-rise"
        >
          Your sales team already works hard.{" "}
          <span className="text-sebyx-accent">
            We make the revenue predictable.
          </span>
        </h1>

        <p
          data-testid="growth-hero-sub"
          className="mt-8 font-body text-base md:text-lg text-sebyx-muted leading-relaxed max-w-2xl sebyx-rise"
        >
          Sebyx works alongside ₹15–100 Cr manufacturing and industrial
          companies — building the sales systems, demand engines and new-market
          entries that turn hard work into predictable orders.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 sebyx-rise">
          <a
            href="#growth-form"
            data-testid="growth-hero-cta"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-sebyx-accent text-sebyx-bg font-semibold text-sm md:text-base hover:bg-[#3FA097] transition-colors"
          >
            Book a Growth Conversation <ArrowRight size={18} />
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="growth-hero-whatsapp"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 border border-sebyx-border text-sebyx-text font-semibold text-sm md:text-base hover:border-sebyx-accent hover:text-sebyx-accent transition-colors"
          >
            <MessageCircle size={18} /> WhatsApp Us
          </a>
        </div>

        <div
          data-testid="growth-hero-trust"
          className="mt-14 pt-8 border-t border-sebyx-border grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl"
        >
          {[
            ["Bengaluru · Nagpur · Indore", "On-ground presence, local advisors"],
            ["Built by an operator", "18 years carrying quota in industrial B2B sales"],
            ["No classroom theory", "Systems that keep producing after the engagement"],
          ].map(([t, d], i) => (
            <div key={t} data-testid={`growth-hero-trust-${i}`}>
              <div className="font-display text-sm md:text-base font-semibold text-sebyx-text">
                {t}
              </div>
              <div className="font-body text-xs md:text-sm text-sebyx-muted mt-1">
                {d}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
